import actual from 'actual'
import deline from './deline'
import envRaw from './env-raw'
import Emitter from './emitter'
import debugFields from './debug-fields'
import forceResize from './force-resize'

import { onEventPassive } from './on-event'

export default viewportResizeProvider()

function viewportResizeProvider() {
  // define viewportResize
  const viewportResize = Emitter('viewportResize')

  viewportResize.width = Emitter('viewportResize::width')
  viewportResize.height = Emitter('viewportResize::height')

  let lastWidth = null
  let lastHeight = null

  // subscribe on event
  onEventPassive(window, 'resize', handler)

  // subscribe on forceResize
  forceResize.emitter.on(manualTrigger)

  // export
  viewportResize.getWidth = getWidth
  viewportResize.getHeight = getHeight
  viewportResize.manualCheck = manualCheck
  viewportResize.manualTrigger = manualTrigger

  return debugFields(viewportResize, {
    _handler: handler,
    _lastSize: lastSize,
    _getActualWidth: getActualWidth,
    _getActualHeight: getActualHeight
  })

  function lastSize() {
    return {
      lastWidth,
      lastHeight
    }
  }

  function getWidth() {
    return lastWidth !== null ? lastWidth : getActualWidth()
  }

  function getHeight() {
    return lastHeight !== null ? lastHeight : getActualHeight()
  }

  function getActualWidth() {
    // the width is trickier to break than the height, but just in case doing the same as below

    if (envRaw.useActualToMeasureViewport) {
      return Math.round(actual('width', 'px'))
    } else {
      return Math.round(document.documentElement.clientWidth)
    }
  }

  function getActualHeight() {
    // document.documentElement.clientHeight excludes the scrollbar and doesn't change on zoom on mobile devices
    // window.innerHeight includes the scrollbar and reduces as the page zooms in on mobile devices
    // visualViewport.height is just new window.innerHeight
    // "actual", which utilizes @media API internally, includes the scrollbar and doesn't change on zoom on mobile devices

    // Considering that, document.documentElement.clientHeight would be the best choice if it were not for clients' pages.
    // Unfortunately, if a client's page is missing a doctype, document.documentElement.clientHeight is equal to document.body.offsetHeight.
    // So, we are checking if documentElement.clientHeight can be trusted and if it's so, using it. Otherwise, falling back to "actual".

    if (envRaw.useActualToMeasureViewport) {
      return Math.round(actual('height', 'px'))
    } else {
      return Math.round(document.documentElement.clientHeight)
    }
  }

  function manualCheck() {
    handler()
  }

  function manualTrigger() {
    lastWidth = null
    lastHeight = null
    handler()
  }

  function handler() {
    const viewportWidth = getActualWidth()
    const viewportHeight = getActualHeight()

    const widthChanged = viewportWidth !== lastWidth
    const heightChanged = viewportHeight !== lastHeight
    const someChanged = widthChanged || heightChanged

    if (widthChanged) lastWidth = viewportWidth
    if (heightChanged) lastHeight = viewportHeight

    if (someChanged) viewportResize.emit(lastWidth, lastHeight)
    if (widthChanged) viewportResize.width.emit(lastWidth, lastHeight)
    if (heightChanged) viewportResize.height.emit(lastWidth, lastHeight)

    if (envRaw.showsViewportResizeDebug) {
      console.debug(deline(`
        ${Date.now()} !viewportResize
          [${widthChanged ? 'W' : '-'}]
          [${heightChanged ? 'H' : '-'}]:
          { width: ${lastWidth}, height: ${lastHeight} }`))
    }
  }
}
